var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortalualogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 654,
    height: 111,
    viewBox: "0 0 654 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_3)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M602.784 61.8297C601.834 70.0536 601.059 74.6654 596.651 82.7829C603.054 86.741 608.591 87.1888 620.712 82.2801L625.54 98.1428H653.127L611.746 0L602.798 0.0688868L602.785 31.7194L614.505 60.5552L602.784 61.8297Z",
    fill: "url(#paint0_linear_231_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 97.9349V0H38.0705C62.6232 0 73.658 14.6212 73.658 34.76C73.658 56.9678 59.0368 68.0026 36.4153 68.0026H25.3803V97.9349H0ZM25.3803 45.3811H33.2427C41.6568 45.3811 46.4845 41.5189 46.4845 34.2082C46.4845 28.1391 42.7603 23.0354 33.2427 23.0354H25.3803V45.3811Z",
    fill: "#FDFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.53 97.9349V23.3113H259.114V0H334.842V23.3113H310.426V97.9349H283.53Z",
    fill: "#FDFDFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.767 97.9349L356.354 0H381.459L416.909 97.9349H389.598L384.631 82.0722C372.349 89.89 365.464 89.673 353.182 82.0722L348.217 97.9349H320.767ZM359.941 60.1403H377.872L369.044 31.8633H368.769L359.941 60.1403Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M425.465 97.9349V0H452.5V74.6236H490.709V97.9349H425.465Z",
    fill: "#FDFDFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M559.399 99.3142C534.845 99.3142 518.293 84.417 518.293 56.8298V0H544.778V55.3125C544.778 65.6577 549.33 74.8995 559.399 74.8995C568.089 74.8995 574.571 67.8648 574.571 55.3125V0H600.917V56.8298C600.917 82.486 586.297 99.3142 559.399 99.3142Z",
    fill: "#FDFDFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.694 99.3137V1.37878H219.868C244.559 1.37878 253.456 15.4484 253.456 35.587C253.456 49.3806 249.801 60.0017 238.765 65.3813L253.456 99.3137H222.972L212.144 69.3815H206.075V99.3137H180.694ZM206.075 46.7598H215.454C223.73 46.7598 228.421 42.8976 228.421 35.587C228.421 29.5178 224.972 24.4142 215.454 24.4142H206.075V46.7598Z",
    fill: "#FDFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_231_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 1,
    width: 124,
    height: 109
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.05 1.09688H64.3965V109.441H187.05V1.09688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_231_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.46 61.1914C124.647 62.5313 121.833 67.5111 123.176 72.3144C124.519 77.1169 129.509 79.9246 134.323 78.5842L129.46 61.1914ZM134.323 78.5842C143.926 75.9111 157.127 68.8019 163.539 55.2889C170.31 41.0159 168.105 22.7724 152.915 1.24912L138.12 11.6456C151.077 30.0055 150.192 41.2178 147.182 47.562C143.812 54.6666 136.126 59.3357 129.46 61.1914L134.323 78.5842Z",
    fill: "url(#paint1_linear_231_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.575 51.9739C134.836 56.9054 138.244 61.5006 143.187 62.2377C148.128 62.9747 152.734 59.5743 153.473 54.6426L135.575 51.9739ZM153.473 54.6426C154.947 44.8037 153.83 29.8765 144.083 18.5211C133.788 6.52684 116.197 1.09034 90.3066 6.14261L93.7797 23.8643C115.865 19.5545 125.763 24.9358 130.338 30.2671C135.462 36.2374 136.598 45.1438 135.575 51.9739L153.473 54.6426Z",
    fill: "url(#paint2_linear_231_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.144 45.1716C131.772 48.6001 137.499 48.4443 140.935 44.8237C144.371 41.203 144.216 35.4884 140.587 32.0599L128.144 45.1716ZM140.587 32.0599C133.347 25.2198 120.444 17.5846 105.534 19.0539C89.7842 20.6056 75.2435 31.8815 64.5664 55.9532L81.1145 63.2614C90.2222 42.7276 100.312 37.7134 107.312 37.0237C115.151 36.2513 123.119 40.4233 128.144 45.1716L140.587 32.0599Z",
    fill: "url(#paint3_linear_231_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19 47.9391C127.188 47.9538 131.251 43.9235 131.265 38.9371C131.28 33.9508 127.241 29.8967 122.244 29.8819L122.19 47.9391ZM122.244 29.8819C112.274 29.8525 97.6344 33.1181 87.7865 44.3857C77.3845 56.2876 74.5423 74.4431 83.3031 99.2733L100.372 93.2768C92.8993 72.0956 96.8014 61.5443 101.425 56.2542C106.603 50.3301 115.27 47.9187 122.19 47.9391L122.244 29.8819Z",
    fill: "url(#paint4_linear_231_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.032 55.0847C117.755 50.4041 115.349 45.2159 110.659 43.4966C105.968 41.7772 100.768 44.1777 99.0454 48.8582L116.032 55.0847ZM99.0454 48.8582C95.6077 58.1963 93.6754 73.04 100.918 86.1283C108.568 99.9528 124.694 108.828 151.073 109.106L151.265 91.05C128.762 90.8125 120.16 83.5441 116.76 77.3993C112.952 70.5188 113.646 61.5671 116.032 55.0847L99.0454 48.8582Z",
    fill: "url(#paint5_linear_231_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.123 63.3526C119.539 59.8781 113.811 59.961 110.329 63.5376C106.847 67.1143 106.93 72.8304 110.514 76.3047L123.123 63.3526ZM110.514 76.3047C117.665 83.2367 130.469 91.0355 145.398 89.756C161.165 88.405 175.849 77.3153 186.834 53.3816L170.38 45.8633C161.011 66.2795 150.858 71.1644 143.85 71.765C136.001 72.4378 128.088 68.1642 123.123 63.3526L110.514 76.3047Z",
    fill: "url(#paint6_linear_231_3)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_3",
    x1: 653.127,
    y1: 39.2571,
    x2: 588.853,
    y2: 58.8381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_231_3",
    x1: 144.61,
    y1: 12.1167,
    x2: 122.695,
    y2: 68.0588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652674,
    stopColor: "#FF6A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_231_3",
    x1: 96.597,
    y1: 18.9842,
    x2: 146.107,
    y2: 57.9035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628568,
    stopColor: "#FF6200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_231_3",
    x1: 79.7294,
    y1: 46.0701,
    x2: 143.09,
    y2: 40.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9500",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369529,
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_231_3",
    x1: 93.017,
    y1: 87.9764,
    x2: 99.6056,
    y2: 60.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_231_3",
    x1: 137.992,
    y1: 98.7088,
    x2: 109.667,
    y2: 44.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497796,
    stopColor: "#FF9101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_231_3",
    x1: 170.698,
    y1: 46.0705,
    x2: 109.392,
    y2: 64.5361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5810",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686259,
    stopColor: "#FF5810"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 654,
    height: 110.147,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalualogo);
export default __webpack_public_path__ + "static/media/Portal ua logo.481673956543d5018c1722ebe3a96012.svg";
export { ForwardRef as ReactComponent };